import localforage from 'localforage'

export const poisIndexeddbStore = localforage.createInstance({
  name: 'venue-finder',
  storeName: 'pois',
  driver: localforage.INDEXEDDB,
})

export const leafletIndexeddbStore = localforage.createInstance({
  name: 'venue-finder',
  storeName: 'tiles',
  driver: localforage.INDEXEDDB,
})

// Add database deletion method to store instance because it doesn't exist
poisIndexeddbStore.deleteDatabase = (name) => new Promise((resolve, reject) => {
  const request = indexedDB.deleteDatabase('venue-finder')

  request.onsuccess = () => resolve()
  request.onerror = () => reject('DB deletion failed')
})

export const localstorageStore = localforage.createInstance({
  name: 'venue-finder',
  driver: localforage.LOCALSTORAGE,
})
